import InfoIcon from "@assets/images/info.png";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    subBody: {
      marginTop: 12,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 21,
      backgroundColor: "#ffffff",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: "6px",
      columnGap: "8px"
    },
    tableTitle: {
      marginTop: 55,
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      height: 50
    }
  }),
  { name: "EmptyProduct" }
);

interface EmptyProduct {
  hideTotal?: boolean;
}

const EmptyProduct: React.FC<EmptyProduct> = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.subBody}>
        <img src={InfoIcon} alt="" />
        <MyTypography variant="body3" style={{ color: "#555555" }}>
          <FormattedMessage defaultMessage="ไม่มีสินค้าในคำสั่งซื้อนี้" />
        </MyTypography>
      </div>
    </>
  );
};

export default EmptyProduct;
